export const UPDATE_PAGE = 'UPDATE_PAGE'

export const updatePage = (newPage) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PAGE, currentPage: newPage })
  }
}
